// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { focusStyles, iconScalableStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

/* Store Custom Code - Start */
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Store Custom Code - End */

export const linkStyles = (color: string, hoverColor: string | null, underline: boolean, hoverUnderline: boolean) => {
    const _hoverColor = hoverColor || color;

    return css`
        ${focusStyles()}
        transition: ${transitionHoverStyles("color")};
        color: ${getColor(color)};
        text-decoration: ${underline ? "underline" : "none"};
        vertical-align: top;
        /* Store Custom Code - Start */
        font-weight: ${x => x.theme.design.typography.weight.bold};
        /* Store Custom Code - End */

        &:hover,
        &:active {
            color: ${getColor(_hoverColor)};
            text-decoration: ${hoverUnderline ? "underline" : "none"};
        }

        &:disabled {
            color: ${getColor("text.disabled")};
            text-decoration: ${underline ? "underline" : "none"};
            cursor: default;
        }
    `;
};

export const linkAltStyles = () => linkStyles("text.linkAlt", "text.linkAltHover", false, true);

export const linkActionStyles = (fontSize?: string) => css`
    ${({ theme }) => css`
        ${theme.link.defaultProps?.css}
        font-size: ${fontSize || theme.design.typography.size.smaller};
        font-weight: ${theme.design.typography.weight.medium /* Store Custom Code */};
        line-height: ${theme.design.typography.lineHeight.semi};
    `}
`;

export const linkIconStyles = (size = "1.15em", spacing = "0.25em" /* Store Custom Code */) => css`
    ${iconScalableStyles(size)}
    margin-right: ${spacing};
    margin-left: ${spacing};

    &:first-child {
        margin-left: 0;
    }

    &:last-child {
        margin-right: 0;
    }
`;

export const linkPageTypeStyles = () => css`
    ${x => x.theme.link.defaultProps?.css}
    font-weight: ${x => x.theme.design.typography.weight.medium /* Store Custom Code */};
`;

/* Store Custom Code - Start */
export const linkUnderlineStyle = (color: string, hoverColor: string = color) => {
    return css`
        position: relative;

        &::after {
            content: "";
            position: absolute;
            bottom: 0;
            display: block;
            width: 100%;
            height: 1px;
            background-color: ${getColor(color)};
            transform: scaleX(1) translateX(0);
            transition: ${transitionHoverStyles("transform")};
        }

        &:hover {
            &::after {
                background-color: ${getColor(hoverColor)};
                transform: scaleX(0.5);
            }
        }
    `;
};

export const linkTranslatableIcon = (hasBackgroundOnHover = false) => {
    return css`
        ${hasBackgroundOnHover &&
        css`
            transition: ${transitionHoverStyles("background-color")};
        `}

        &:hover {
            ${hasBackgroundOnHover &&
            css`
                background-color: ${getColor("common.accent")};
            `}

            [class^="IconWrapper"] {
                transform: translateX(${pxToRem(5)});
            }
        }

        [class^="IconWrapper"] {
            transition: ${transitionHoverStyles("transform")};
        }
    `;
};

export const linkButtonStyles = (fontSize?: string) => css`
    ${({ theme }) => css`
        ${linkStyles("primary", "text", false, true)}
        font-size: ${fontSize || theme.design.typography.size.smaller};
        font-weight: ${theme.design.typography.weight.bold};
        line-height: ${theme.design.typography.lineHeight.small};
        text-transform: uppercase;
    `}
`;
/* Store Custom Code - End */
